import { cn } from "@/lib/utils";

export function Column({
  id,
  ref,
  wide,
  noGap,
  start,
  bigGap,
  center,
  between,
  onClick,
  children,
  tightGap,
  className,
  tighterGap,
  fullHeight,
  dotPattern,
  gridPattern,
}: {
  id?: string;

  wide?: boolean;
  noGap?: boolean;
  start?: boolean;
  bigGap?: boolean;
  center?: boolean;
  between?: boolean;
  className?: string;
  tightGap?: boolean;
  tighterGap?: boolean;
  fullHeight?: boolean;
  dotPattern?: boolean;
  gridPattern?: boolean;
  onClick?: () => void;
  children?: React.ReactNode;
  ref?: React.RefObject<HTMLDivElement>;
}) {
  return (
    <div
      id={id}
      ref={ref}
      className={cn(
        "flex flex-col gap-4",
        noGap && "gap-0",
        tighterGap && "gap-1",
        tightGap && "gap-2",
        bigGap && "gap-8",
        wide && "w-full",
        fullHeight && "h-full",
        dotPattern && "relative isolate",
        between && "items-between justify-between",
        center && "items-center",
        start && "items-start",
        className,
      )}
      onClick={onClick}
    >
      {dotPattern && (
        <div className="absolute inset-0 -z-10 h-full w-full bg-[radial-gradient(circle_at_1px_1px,rgb(0_0_0/0.1)_1px,transparent_0)] bg-size-[16px_16px] translate-x-[10px] translate-y-[10px]" />
      )}
      {gridPattern && (
        // GRID:
        //       background-size: 40px 40px;
        // background-image:
        //   linear-gradient(to right, grey 1px, transparent 1px),
        //   linear-gradient(to bottom, grey 1px, transparent 1px);
        <div className="absolute inset-0 -z-10 h-full w-full bg-[linear-gradient(to_right,rgb(0_0_0/0.1)_1px,transparent_1px),linear-gradient(to_bottom,rgb(0_0_0/0.1)_1px,transparent_1px)] bg-size-[40px_40px] translate-x-[10px] translate-y-[10px] opacity-40" />
      )}
      {children}
    </div>
  );
}
